import { Web } from 'sip.js';

const { SimpleUser } = Web;

let simpleUser = null;
let sessionConfig = null;

function dispatchEvent(name, detail = {}) {
  document.dispatchEvent(new CustomEvent(name, { detail }));
}

function getUserMedia() {
  return navigator.mediaDevices.getUserMedia({ audio: true, video: false });
}

export async function initializeSession(tokenResponse) {
  if (simpleUser) return;

  sessionConfig = tokenResponse;
  const { websocket_url, sip_username, sip_password, sip_server, ice_servers } = tokenResponse;
  const sipUri = `sip:${sip_username}@${sip_server}`;

  const delegate = {
    onCallReceived: () => {
      dispatchEvent('sip:incoming-call', {
        from: simpleUser?.remoteIdentity?.uri?.user,
        callSid: simpleUser?.id,
      });
    },
    onCallAnswered: () => {
      dispatchEvent('sip:call-answered');
    },
    onCallHangup: () => {
      dispatchEvent('sip:call-ended');
      simpleUser = null;
    },
    onRegistered: () => {
      dispatchEvent('sip:registered', { identity: sip_username });
    },
    onUnregistered: () => {
      dispatchEvent('sip:unregistered');
    },
    onServerConnect: () => {
      dispatchEvent('sip:server-connect');
    },
    onServerDisconnect: () => {
      dispatchEvent('sip:server-disconnect');
    },
  };

  simpleUser = new SimpleUser(websocket_url, {
    delegate,
    uri: sipUri,
    authorizationUsername: sip_username,
    authorizationPassword: sip_password,
    userAgentOptions: {
      sessionDescriptionHandlerFactoryOptions: {
        peerConnectionConfiguration: {
          iceServers: ice_servers || [{ urls: 'stun:stun.l.google.com:19302' }],
        },
      },
    },
  });

  await simpleUser.connect();
  await simpleUser.register();

  return simpleUser;
}

export async function answer() {
  if (!simpleUser) throw new Error('No session');
  await simpleUser.answer();
}

export function endClientCall() {
  if (simpleUser) {
    simpleUser.hangup().catch(() => {});
    simpleUser.unregister().catch(() => {});
    simpleUser.disconnect().catch(() => {});
    simpleUser = null;
  }
  sessionConfig = null;
}

export function setMuted(muted) {
  if (simpleUser) {
    if (muted) {
      simpleUser.mute().catch(() => {});
    } else {
      simpleUser.unmute().catch(() => {});
    }
  }
}

export function isRegistered() {
  return simpleUser?.isConnected() || false;
}

export default {
  initializeSession,
  answer,
  endClientCall,
  setMuted,
  isRegistered,
};